import React from "react";
import { motion } from "framer-motion";
import { Mail, Download, Image as ImageIcon, FileText, ArrowRight } from "lucide-react";
import { trackBookDownload } from "../lib/trackBookDownload";

const BOOK_PDF =
  "https://customer-assets.emergentagent.com/job_ya-digital/artifacts/riplp2t7_Resumen_por_capitulos_Capitalismo_de_Abundancia.pdf";

const PRESS_EMAIL = "prensa@frenteya.com.ar";

export const PressSection = () => {
  return (
    <section
      id="prensa"
      className="relative bg-white py-24 md:py-32 overflow-hidden"
      data-testid="press-section"
    >
      <div aria-hidden className="absolute -top-32 -right-20 w-96 h-96 bg-[#0A2463]/5 blur-3xl rounded-full" />
      <div className="relative max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#0A2463]" />
              <span className="font-headings text-xs tracking-[0.3em] uppercase text-[#0A2463]">
                Prensa
              </span>
            </div>
            <h2 className="font-headings font-bold uppercase tracking-tight text-[#0A192F] text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Sala de <span className="fy-underline">prensa</span>
            </h2>
            <p className="mt-6 text-lg text-[#4B5563] leading-relaxed">
              Frente Ya es un movimiento abierto. Si sos periodista, productor/a, conductor/a o
              referente de medios, te facilitamos toda la información para que puedas cubrir
              nuestra propuesta.
            </p>

            <a
              href={`mailto:${PRESS_EMAIL}?subject=Consulta%20de%20prensa%20%C2%B7%20Frente%20Ya`}
              className="mt-8 group inline-flex items-center gap-3 bg-[#0A2463] hover:bg-[#0A192F] text-white font-headings uppercase tracking-wide text-base px-7 py-4 transition-colors"
              data-testid="press-email-btn"
            >
              <Mail size={18} />
              {PRESS_EMAIL}
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </a>

            <p className="mt-4 text-xs text-[#9CA3AF] uppercase tracking-[0.2em] font-headings">
              Respondemos en menos de 24 horas hábiles.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-px bg-gray-200 border border-gray-200">
              <PressCard
                icon={<FileText className="text-[#F5B400]" size={22} />}
                title="Manifiesto del movimiento"
                description="Libro completo Capitalismo de Abundancia · 200 páginas · 30 capítulos."
                cta="Descargar PDF"
                href={BOOK_PDF}
                onClick={() => trackBookDownload("press-section")}
                external
              />
              <PressCard
                icon={<ImageIcon className="text-[#F5B400]" size={22} />}
                title="Logos y assets visuales"
                description="Logo principal, isotipo y placas en PNG/SVG para uso editorial."
                cta="Solicitar por email"
                href={`mailto:${PRESS_EMAIL}?subject=Pedido%20de%20logos%20y%20assets`}
              />
              <PressCard
                icon={<Mail className="text-[#F5B400]" size={22} />}
                title="Vocero / entrevistas"
                description="Coordinación de notas, reportajes y participación en programas."
                cta="Coordinar entrevista"
                href={`mailto:${PRESS_EMAIL}?subject=Solicitud%20de%20entrevista`}
              />
              <PressCard
                icon={<Download className="text-[#F5B400]" size={22} />}
                title="Bio breve del fundador"
                description="Claudio Alejandro Nazar · Bio resumida y currículum público."
                cta="Pedir bio"
                href={`mailto:${PRESS_EMAIL}?subject=Pedido%20de%20bio%20del%20fundador`}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const PressCard = ({ icon, title, description, cta, href, external, onClick }) => (
  <a
    href={href}
    target={external ? "_blank" : undefined}
    rel={external ? "noopener noreferrer" : undefined}
    onClick={onClick}
    className="group bg-white p-6 sm:p-7 hover:bg-gray-50 transition-colors"
    data-testid={`press-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
  >
    <div className="flex items-center gap-3 mb-4">
      <div className="w-10 h-10 bg-[#0A2463]/5 border border-[#0A2463]/10 flex items-center justify-center group-hover:bg-[#F5B400]/15 transition-colors">
        {icon}
      </div>
      <h3 className="font-headings uppercase tracking-wide text-sm text-[#0A192F] flex-1 leading-tight">
        {title}
      </h3>
    </div>
    <p className="text-sm text-[#4B5563] leading-relaxed">{description}</p>
    <div className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#0A2463] font-headings">
      {cta}
      <ArrowRight size={12} className="group-hover:translate-x-1 transition-transform" />
    </div>
  </a>
);

export default PressSection;
